(function () {
  var rapidSearchSelector = '.rps-results, .rps-result-page-wrapper';
  var productLinkSelector = '.rps-results a[href*="/products/"], .rps-result-page-wrapper a[href*="/products/"]';
  var pending = false;
  var lastSignature = '';

  // When notifyStoq() fires before STOQ has loaded, we record that a retry is
  // needed. Once STOQ's API appears we reset the signature and re-trigger so
  // the preorder buttons render without requiring a pagination click.
  var stoqRetryPending = false;
  var stoqPollerActive = false;

  var LOG = '[CC Bridge]';

  function isStoqAvailable() {
    // STOQ registers as window._RestockRocket (leading underscore)
    return !!(
      (window._RestockRocket && typeof window._RestockRocket.renderButtonsForPage === 'function') ||
      (window.RestockRocket && (
        typeof window.RestockRocket.refresh === 'function' ||
        typeof window.RestockRocket.renderCollection === 'function'
      )) ||
      (window.restockRocket && (
        typeof window.restockRocket.refresh === 'function' ||
        typeof window.restockRocket.renderCollection === 'function'
      ))
    );
  }

  function startStoqPoller() {
    if (stoqPollerActive) return;
    stoqPollerActive = true;
    console.log(LOG, 'STOQ not ready — starting poller');

    var attempts = 0;
    var maxAttempts = 60; // poll for up to 6 seconds
    var interval = setInterval(function () {
      attempts++;

      if (isStoqAvailable()) {
        clearInterval(interval);
        stoqPollerActive = false;
        console.log(LOG, 'STOQ became available after', attempts * 100 + 'ms');

        if (stoqRetryPending && getRapidSearchSignature()) {
          stoqRetryPending = false;
          // Reset signature so scheduleNotify treats this as a new render
          lastSignature = '';
          console.log(LOG, 'Retrying notification now that STOQ is ready');
          scheduleNotify();
        } else {
          console.log(LOG, 'STOQ ready but no pending retry or no RPS products found');
        }
        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
        stoqPollerActive = false;
        stoqRetryPending = false;
        console.warn(LOG, 'STOQ did not load within 6s — giving up');
      }
    }, 100);
  }

  function callIfFunction(target, method) {
    if (target && typeof target[method] === 'function') {
      target[method]();
    }
  }

  function dispatchEvent(target, name, detail) {
    if (!target || typeof target.dispatchEvent !== 'function') return;

    var event;
    if (typeof CustomEvent === 'function') {
      event = new CustomEvent(name, { detail: detail });
    } else {
      event = new Event(name);
      event.detail = detail;
    }

    target.dispatchEvent(event);
  }

  function notifyStoq() {
    var stoqReady = isStoqAvailable();
    var detail = { source: 'cinema-cellar-rapid-search-bridge' };

    console.log(LOG, 'notifyStoq() —',
      'STOQ ready:', stoqReady,
      '| _RestockRocket:', typeof window._RestockRocket,
      '| RPS products:', document.querySelectorAll(productLinkSelector).length
    );

    // Primary STOQ API (confirmed global name from live inspection)
    callIfFunction(window._RestockRocket, 'renderButtonsForPage');

    // Fallback: legacy/alternate namespaces
    var fallbackTargets = [window.RestockRocket, window.restockRocket].filter(function (t, i, arr) {
      return t && arr.indexOf(t) === i;
    });
    fallbackTargets.forEach(function (target) {
      callIfFunction(target, 'refresh');
      callIfFunction(target, 'renderCollection');
      callIfFunction(target, 'renderCollectionBadges');
    });

    dispatchEvent(document, 'stoq:refresh', detail);
    dispatchEvent(window, 'stoq:refresh', detail);
    dispatchEvent(document, 'restockrocket:refresh', detail);
    dispatchEvent(window, 'restockrocket:refresh', detail);
    dispatchEvent(document, 'shopify:section:load', detail);
    dispatchEvent(window, 'shopify:section:load', detail);

    // If STOQ wasn't loaded yet, queue a retry for when it appears.
    if (!stoqReady) {
      stoqRetryPending = true;
      startStoqPoller();
    }
  }

  function getRapidSearchSignature() {
    var links = document.querySelectorAll(productLinkSelector);

    if (!links.length) return '';

    return Array.prototype.map.call(links, function (link) {
      return link.getAttribute('href') || '';
    }).join('|');
  }

  function scheduleNotify() {
    if (pending) return;

    pending = true;
    setTimeout(function () {
      pending = false;

      var signature = getRapidSearchSignature();

      if (!signature) {
        // Log what selectors ARE in the DOM to diagnose selector mismatches
        var rpsContainers = document.querySelectorAll('[class*="rps-"]');
        var rpsClasses = Array.prototype.map.call(rpsContainers, function (el) {
          return el.tagName.toLowerCase() + '.' + el.className.trim().replace(/\s+/g, '.');
        }).slice(0, 10);
        console.log(LOG, 'scheduleNotify fired — no product links found via selector. RPS elements in DOM:', rpsClasses.join(', ') || 'none');
        return;
      }

      if (signature === lastSignature) return;

      console.log(LOG, 'RPS products changed — firing STOQ notification (' + signature.split('|').length + ' products)');
      lastSignature = signature;
      notifyStoq();
    }, 50);
  }

  function observeRapidSearch(container) {
    if (!container || container.dataset.stoqRapidSearchBridgeObserved === 'true') return;

    console.log(LOG, 'Attaching observer to RPS container:', container.className || container.id || container.tagName);

    new MutationObserver(scheduleNotify).observe(container, {
      childList: true,
      subtree: true,
    });

    container.dataset.stoqRapidSearchBridgeObserved = 'true';
    scheduleNotify();
  }

  // Fallback scanner: RPS renders in stages (skeleton → filters → products),
  // and the MutationObserver can miss the final product injection if it fires
  // between debounce windows. This scans at increasing intervals after load
  // to catch any products the observer missed.
  function startFallbackScanner() {
    var delays = [300, 600, 1000, 1500, 2500, 4000];
    delays.forEach(function (delay) {
      setTimeout(function () {
        var sig = getRapidSearchSignature();

        if (!sig) {
          // Diagnostic: show what RPS links ARE in the DOM at this point
          var anyRpsLinks = document.querySelectorAll('.rps-results a[href], .rps-result-page-wrapper a[href], .rps-products-container a[href]');
          if (anyRpsLinks.length) {
            var sample = Array.prototype.map.call(anyRpsLinks, function (a) {
              return a.getAttribute('href');
            }).slice(0, 5);
            console.log(LOG, 'Fallback at ' + delay + 'ms — RPS links found but not matching /products/ selector. Sample hrefs:', sample.join(', '));
          } else {
            console.log(LOG, 'Fallback at ' + delay + 'ms — no RPS products in DOM yet');
          }
          return;
        }

        if (sig !== lastSignature) {
          console.log(LOG, 'Fallback scanner found products at ' + delay + 'ms (' + sig.split('|').length + ' products)');
          lastSignature = sig;
          notifyStoq();
        }
      }, delay);
    });
  }

  function init() {
    console.log(LOG, 'init() — readyState:', document.readyState, '| STOQ available:', isStoqAvailable());

    document.querySelectorAll(rapidSearchSelector).forEach(observeRapidSearch);

    new MutationObserver(function () {
      document.querySelectorAll(rapidSearchSelector).forEach(function (container) {
        if (container.dataset.stoqRapidSearchBridgeObserved !== 'true') {
          observeRapidSearch(container);
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });

    startFallbackScanner();
  }

  window.__CinemaCellarStoqRapidSearchBridge = {
    notifyStoq: notifyStoq,
    scheduleNotify: scheduleNotify,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
